/* eslint-disable @typescript-eslint/ban-types */
import { InputAdornment } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { renderErrorInField, renderUpdatedInField } from '@flatsy/utils/Functions/form/Helpers'
import CompareArrowsIcon from '@material-ui/icons/CompareArrows'
import FormTextField from '../../../../../../Global/TextField'
import { SingleFieldProps } from '../../../../../Types'
import theme from '../../../../../../../MuiTheme/theme'
import { Body2 } from '../../../../../../../MaterialUi/Typo'
import { useStyles } from './Style'

const CustomRatioField = <T extends {}>({
  field,
  input,
  meta,
  justSubmitted,
}: SingleFieldProps<T>): React.ReactElement => {
  const classes = useStyles()
  const [ratioValue, setRatioValue] = useState<number | null>(null)

  /**
   * @description event when input change
   * @param val
   */
  const onChangeRatio = (val: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const { value } = val.target
    if (value) {
      if (typeof value === 'string') {
        setRatioValue(parseFloat(value))
        input.onChange(Math.round(100 / parseFloat(value)))
      } else {
        setRatioValue(value)
        input.onChange(Math.round(100 / value))
      }
    } else {
      setRatioValue(null)
      input.onChange(Math.round(100 / 0))
    }
  }

  const onChangeValue = (val: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const { value } = val.target
    if (value) {
      if (typeof value === 'string') {
        setRatioValue(Math.round((100 / parseInt(value)) * 100) / 100)
        input.onChange(parseInt(value))
      } else {
        setRatioValue(Math.round((100 / value) * 100) / 100)
        input.onChange(parseInt(value))
      }
    } else {
      setRatioValue(null)
      input.onChange(Math.round(100 / 0))
    }
  }

  useEffect(() => {
    if (input && input.value && !ratioValue && ratioValue === null) {
      if (typeof input.value === 'string') {
        if (parseInt(input.value) > 0) {
          setRatioValue(Math.round((100 / parseInt(input.value)) * 100) / 100)
        }
      } else if (parseInt(input.value) > 0) {
        setRatioValue(Math.round((100 / input.value) * 100) / 100)
      }
    }
  }, [input, ratioValue])

  return (
    <div className={classes.fieldContainer}>
      <FormTextField
        error={renderErrorInField(meta)}
        updated={renderUpdatedInField(meta, justSubmitted)}
        label={field.customProperties?.field1Label}
        {...input}
        onChange={onChangeValue}
        fullWidth
        type="number"
        className={classes.field}
        InputLabelProps={{ shrink: true }}
        InputProps={{
          endAdornment: <InputAdornment position="end">%</InputAdornment>,
        }}
      />
      <div className={classes.fieldSeparatorContainer}>
        <Body2 fontColor={theme.palette.secondary.dark}>ou</Body2>
        <CompareArrowsIcon className={classes.fieldSeparatorIcon} />
      </div>
      <FormTextField
        error={renderErrorInField(meta)}
        updated={renderUpdatedInField(meta, justSubmitted)}
        label={field.customProperties?.field2Label}
        {...input}
        value={ratioValue}
        onChange={onChangeRatio}
        fullWidth
        type="number"
        className={classes.field}
        InputLabelProps={{ shrink: true }}
        InputProps={{
          endAdornment: <InputAdornment position="end">fois</InputAdornment>,
        }}
      />
    </div>
  )
}

export default CustomRatioField
